module.exports = __webpack_public_path__ + "img/4.6e8c55da.png";